var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-headers" },
    [
      _c(
        "div",
        { staticClass: "table-header-cell record-id-header" },
        [
          _c("a-checkbox", {
            attrs: { checked: _vm.isAllSelected },
            on: {
              change: function ($event) {
                return _vm.$emit("toggle-select-all", $event.target.checked)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "drag-context-wrapper",
          attrs: { list: _vm.$_.cloneDeep(_vm.visibleFields) },
          on: { end: _vm.onDragEnd },
        },
        _vm._l(_vm.visibleFields, function (field) {
          return _c(
            "div",
            {
              key: field._id,
              staticClass: "table-header-cell",
              class: {
                selected: _vm.selectedField === field,
                identifier: field.isIdentifierField,
              },
              on: {
                click: function ($event) {
                  return _vm.selectField(field)
                },
              },
            },
            [
              _c(
                "a-popover",
                { attrs: { trigger: "click", placement: "bottomLeft" } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { staticClass: "action-list field-actions-menu" },
                      [
                        !_vm.moduleMode
                          ? _c(
                              "div",
                              {
                                staticClass: "action-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAction("editField", field)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("edit"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.editField"))),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.moduleMode ? _c("a-divider") : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "action-group" }, [
                          _c("div", { staticClass: "group-name" }, [
                            _vm._v(_vm._s(_vm.$t("tables.sort"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "action-item",
                              class: { disabled: field.valueType === "array" },
                              on: {
                                click: function ($event) {
                                  field.valueType !== "array" &&
                                    _vm.handleAction("sortAscending", field)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("arrow_upward"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("tables.ascending"))),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "action-item",
                              class: { disabled: field.valueType === "array" },
                              on: {
                                click: function ($event) {
                                  field.valueType !== "array" &&
                                    _vm.handleAction("sortDescending", field)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("arrow_downward"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("tables.descending"))),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          !field.isIdentifierField &&
                          _vm.isValidForIdentifier(field)
                            ? _c(
                                "div",
                                {
                                  staticClass: "action-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAction(
                                        "makeIdentifier",
                                        field
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("check_circle"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Mark as Identifier Field"))
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          field.fieldType === "ai"
                            ? _c(
                                "div",
                                {
                                  staticClass: "action-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAction("runAI", field)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("auto_awesome"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Yapay Zekayı Çalıştır"))
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("a-divider"),
                        _vm._v(" "),
                        false
                          ? _c("div", { staticClass: "action-group" }, [
                              _c("div", { staticClass: "group-name" }, [
                                _vm._v(_vm._s(_vm.$t("tables.createField"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "action-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAction(
                                        "insertBefore",
                                        field
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("tables.insertBefore"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "action-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAction(
                                        "insertAfter",
                                        field
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("tables.insertBefore"))
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        false ? _c("a-divider") : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "action-group" }, [
                          _c("div", { staticClass: "group-name" }, [
                            _vm._v(_vm._s(_vm.$t("ticimax.automation"))),
                          ]),
                          _vm._v(" "),
                          field.fieldType === "automation-button"
                            ? _c(
                                "div",
                                {
                                  staticClass: "action-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAction(
                                        "gotoAutomation",
                                        field
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("atomic-power", {
                                    tag: "component",
                                    staticClass: "myIcon",
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("tables.goToRelatedAuto"))
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "action-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleAction(
                                    "createAutomation",
                                    field
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("settings_suggest"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("ticimax.createAutomation"))
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-divider"),
                        _vm._v(" "),
                        _c("div", { staticClass: "action-group" }, [
                          _c("div", { staticClass: "group-name" }, [
                            _vm._v(_vm._s(_vm.$t("tables.permission"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "action-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleAction("lockField", field)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("lock"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("tables.lockField"))),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "action-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleAction("hideField", field)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("visibility_off"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("tables.hideField"))),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-divider"),
                        _vm._v(" "),
                        !_vm.moduleMode
                          ? _c(
                              "div",
                              {
                                staticClass: "action-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAction(
                                      "deleteField",
                                      field
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("delete"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.deleteField"))),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "table-header-cell-content" },
                    [
                      _c("FieldIcon", {
                        staticClass: "mr-2",
                        attrs: {
                          type: field.fieldType,
                          "default-icon": field.icon,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(field.name))]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.moduleMode
        ? _c(
            "div",
            { staticClass: "table-header-cell add-field-cell" },
            [
              _c(
                "a-popover",
                {
                  attrs: {
                    trigger: "click",
                    placement: "bottomRight",
                    overlayClassName: "zero-padding",
                  },
                  model: {
                    value: _vm.isAddFieldPopoverVisible,
                    callback: function ($$v) {
                      _vm.isAddFieldPopoverVisible = $$v
                    },
                    expression: "isAddFieldPopoverVisible",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("FieldSelector", {
                        on: {
                          "field-selected": _vm.openFieldCreator,
                          close: function ($event) {
                            _vm.addFieldPopoverVisible = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("+ " + _vm._s(_vm.$t("calendar.addField"))),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFieldCreatorVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title:
                  _vm.fieldCreatorMode === "create"
                    ? _vm.$t("tables.createNewField")
                    : "Alanı Düzenle",
                showFooter: false,
                className: "field-creator-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeFieldCreator },
            },
            [
              _c("FieldCreator", {
                attrs: {
                  defaultFieldType: _vm.selectedFieldType,
                  "table-id": _vm.table._id,
                  mode: _vm.fieldCreatorMode,
                  field: _vm.selectedField,
                },
                on: {
                  "field-created-success": _vm.onFieldCreated,
                  "field-updated-success": _vm.onFieldUpdated,
                  cancel: _vm.closeFieldCreator,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }